import { render, staticRenderFns } from "./NewsListArticle.vue?vue&type=template&id=ca806160&"
import script from "./NewsListArticle.vue?vue&type=script&lang=js&"
export * from "./NewsListArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports